import React, { useState, Fragment } from 'react';
import { useDispatch } from 'react-redux';
import { Grid, Button, Typography, Divider } from '@material-ui/core';
import { invokePostService, toggleRightDrawer, setFocusElement, setReRender } from '../../../store/global/actions';

export default function DeleteDelegate({ id, element, onClose, onCompletion, setShowDeleteAlert }) {
    const dispatch = useDispatch();
    const [transactionForEvents, setTransactionForEvents] = useState([]);
    const [associatedItems, setAssociatedItems] = useState([]);
    const [isForceDelete, setIsForceDelete] = useState(false);
    const [loading, setLoading] = useState(false);
    
    const onDelete = () => {
        setLoading(true);
        dispatch(invokePostService('deleteClusterlet', { isForceDelete }, [element.id])).then(res => {
            if (res?.status === true) {
                onCompletion('Delegate', 'delete')
            } else {
                if (res?.data?.associatedItems?.length > 0) {
                    setIsForceDelete(true);
                }
                setAssociatedItems(res?.data?.associatedItems ? res?.data?.associatedItems : []);
                setTransactionForEvents(res?.data?.associatedTransaction ? res?.data?.associatedTransaction : []);
                if (res?.code === 254){
                    setShowDeleteAlert(false);
                }
                if (res?.code === 255) {
                    dispatch(toggleRightDrawer());
                    dispatch(setReRender());
                    dispatch(setFocusElement({}));
                }
            }
            setLoading(false);
        });
    }

    return (
        <Grid container direction={"row"} spacing={1} >
            <Grid item xs={12} >
                <Typography variant="h6">Delete</Typography>
            </Grid>
            <Grid item xs={12} >
                <Divider/>
            </Grid>


            {transactionForEvents?.length > 0 && (
                <Grid item xs={12} style={{padding: '10px'}}>
                    <Typography style={{marginBottom: '10px'}}> Are you sure you want to delete Delegate {element?.name}? </Typography>
                    <Typography color="error"> 
                        { transactionForEvents?.length === 1 ? (
                            `This delegate is associated with the transaction '${transactionForEvents[0]}'. Please delete that first.`
                        ) : (
                            `This delegate is associated with multiple transactions. Please delete them first.`
                        )}
                    </Typography>
                </Grid>
            )}


            {transactionForEvents.length === 0 && 
                <Grid item xs={12} style={{padding: '10px'}}>
                    {associatedItems.length > 0 && <Fragment>
                        <Typography> Deleting this node will delete the following entities </Typography>
                        <br />
                        <ol>
                            {associatedItems.map((item, index) =>
                                <li key={index}>  {item} </li>
                            )}
                        </ol>
                    </Fragment>}
                    <Fragment>
                        <Typography> Are you sure you want to delete Delegate {element?.name}? </Typography>
                    </Fragment>
                </Grid>
                }

            <Grid item xs={12} >
                <Divider/>
            </Grid>
            <Grid item xs={12} style={{ display: "flex", justifyContent: "flex-end" }} >
                <Button color="primary" variant="outlined" style={{ marginLeft: 10, textTransform: 'capitalize' }} onClick={onClose}> Cancel </Button>
                <Button color="secondary" variant="contained" style={{ marginLeft: 10, textTransform: 'capitalize' }} onClick={onDelete} disabled={loading || transactionForEvents.length}> {loading ? 'Deleting..' : isForceDelete ? 'Delete Anyway' : 'Delete'} </Button>
            </Grid>


        </Grid >
    )
}
